import CustomerService from "../components/customor_service";
import Edukasi from "../components/edukasi";
import Footer from "../components/footer";
import Navbar from "../components/navbar";

export default function EdukasiLayout() {
    return (
      <>
        <Navbar/>
        <Edukasi/>
        <CustomerService/>
        <Footer/>
      </>
    );
}